import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {Spinner, SpinnerSize, SpinnerStyle} from "@mintdata-wsp/common/components/spinner/Spinner";
import {Row} from "@mintdata-wsp/wsp/ui/components/forms/Row";

const styles = require('./SettingsSpinner.less');
const cx = classnames.bind(styles);

interface SettingsSpinnerProps
{
    isVisible:boolean;
}

@observer
export class SettingsSpinner extends React.Component<SettingsSpinnerProps, any>
{
    render()
    {
        const {isVisible} = this.props;

        if (!isVisible) return null;

        return (
            <Row className={cx('settingsSpinner')}>
                <Spinner
                    size={SpinnerSize.Large_64}
                    style={SpinnerStyle.Blue}
                />
            </Row>
        );
    }
}





